import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as homepageSlice from "../../../../redux/slices/homepageSlice";
import * as customizeSlice from "../../../../redux/slices/customizeSlice";
import * as locationSlice from "../../../../redux/slices/locationSlice";
import { toast } from "react-toastify";
import { imageBaseUrl } from "../../../../helper";
import DataTable from "react-data-table-component"; // Import DataTable
import DeleteModal from "../../components/DeleteModal";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";

const PickupPoint = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);
  const [sortNumber, setSortNumber] = useState(undefined);
  const [showEditTempleModal, setShowEditTempleModal] = useState(false);
  const [imageId, setImageId] = useState(undefined);
  const [bannerType, setBannerType] = useState("Image"); // New state for banner type
  const [selectedVideo, setSelectedVideo] = useState();
  const [thumbnail, setThumbnail] = useState();
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [locationId, setLocationId] = useState();

  const { locationData } = useSelector((state) => state.locationSlice);
  const { allPickupPoints, loading } = useSelector((state) => state.customizeSlice);

  // Modal state for adding temple
  const [showAddTempleModal, setShowAddTempleModal] = useState(false);


  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
    dispatch(customizeSlice.getPickupPoints());
    dispatch(locationSlice.getLocation());
  }, [dispatch]);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
  }, [showEditTempleModal]);

  // Handle delete
  const handleDelete = (locationId) => {
    setDeleteModal(true);
    setDeletableId(locationId);
  };

  const handleDeleteImage = async () => {
    await dispatch(customizeSlice.destroyPickupPoint(deletableId));
    dispatch(customizeSlice.getPickupPoints());
    setDeleteModal(false);
  };

  // DataTable columns definition
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Pickup Point Name",
      selector: (row) => row?.pickup_name || "-",
      sortable: true,
    },
    {
      name: "Destination Name",
      selector: (row) => row?.destination?.destination_name || "-",
      sortable: true,
    },
    {
      name: "Latitude",
      selector: (row) => row?.latitude || "-",
      sortable: true,
    },
    {
      name: "Longitude",
      selector: (row) => row?.longitude || "-",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div>
          <div
            className="edit ml-1"
            onClick={(e) => {
              handleOnEditClick(row.id);
              setShowAddTempleModal(true);
              setIsEdit(true);
            }}
          >
            <NotePencil size={18} />
          </div>
        </div>
      ),
    },
  ];

  const handleOnEditClick = (id) => {
    const data = allPickupPoints?.find((h) => h?.id === id);
    setLocationId(data?.id);
    // console.log(data,"pay")
    setForm({
      ...form,
      destination_id: data?.destination_id,
      pickup_name: data?.pickup_name,
      lat: data?.latitude,
      long: data?.longitude,
    });
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    const { destination_id,pickup_name, lat, long } = form;

    console.log(form,"pay")
    formData.append("destination_id", destination_id);
    formData.append("pickup_name", pickup_name);
    formData.append("lat", lat);
    formData.append("long", long);
   
    await dispatch(customizeSlice.updatePickupPoint(formData, locationId, setForm));
    setSelectedImage(null);
    setPreviewImage(null);
    setShowAddTempleModal(false);
    dispatch(customizeSlice.getPickupPoints());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    const { destination_id, lat, long,pickup_name } = form;

    if (!destination_id) {
      toast("Please select destination");
      return;
    }
    if (!pickup_name) {
      toast("Please enter point name");
      return;
    }
    if (!lat) {
      toast("Please enter latitude");
      return;
    }
    if (!long) {
      toast("Please enter longitude");
      return;
    }

    formData.append("destination_id", destination_id);
    formData.append("pickup_name", pickup_name);
    formData.append("lat", lat);
    formData.append("long", long);

    await dispatch(customizeSlice.storePickupPoint(formData, setForm));
    setShowAddTempleModal(false);
    dispatch(customizeSlice.getPickupPoints());
  };

  console.log(allPickupPoints,"allPickupPoints")
  return (
    <>
      <h5 className="mb-4"> Pickup Points</h5>

      <Row className="mt-4">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <h6>Added Points:</h6>
          <Button
            style={{
              backgroundColor: "#e8783d",
              border: "none",
              marginBottom: "1vh",
            }}
            onClick={() => {
              setIsEdit(false);
              setForm({});
              setShowAddTempleModal(true);
            }}
          >
            Add pickup Point
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={(allPickupPoints?.length && allPickupPoints) || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        handleDelete={handleDeleteImage}
        name={"Pickup Point"}
      />

      {/* Add Banner Modal */}
      <Modal
        show={showAddTempleModal}
        onHide={() => setShowAddTempleModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w" // Optional: To make the modal wider
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? "Update" : "Add"} Pickup Point
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="templeSelect" className="mb-3">
            <Form.Label>Select Destination</Form.Label>
            <Form.Select   value={form.destination_id || ""} onChange={(e) => setForm({...form,destination_id:e.target.value})}>
              <option value="">Select Temple</option>
              {locationData?.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.destination_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Pickup Point Name</Form.Label>
              <Form.Control
                type="text"
                value={form?.pickup_name}
                onChange={(e) =>
                  setForm({ ...form, pickup_name: e.target.value })
                }
                placeholder="Enter pickup point"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Lat</Form.Label>
              <Form.Control
                type="number"
                value={form?.lat}
                onChange={(e) => setForm({ ...form, lat: e.target.value })}
                placeholder="Enter lat"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Long</Form.Label>
              <Form.Control
                type="number"
                value={form?.long}
                onChange={(e) => setForm({ ...form, long: e.target.value })}
                placeholder="Enter long"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddTempleModal(false)}
          >
            Close
          </Button>
          {isEdit ? (
            <Button variant="primary" type="submit" onClick={handleUpdate}>
              Update 
            </Button>
          ) : (
            <Button variant="primary" type="submit" onClick={handleSubmit}>
              Save
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PickupPoint;
